<template>
  <div class="">
    <el-card>
      <div slot="header" class="clearfix flex justify-between">
        <span>{{ $t('transactionLogManage.queryCondition') }}</span>
      </div>
      <el-form :inline="true" :model="transactionLogManageInfo.conditions" class="flex justify-start">
        <el-form-item>
          <el-input v-model="transactionLogManageInfo.conditions.transactionId"
            :placeholder="$t('transactionLogManage.inputTransactionId')" clearable />
        </el-form-item>
        <el-form-item>
          <el-input v-model="transactionLogManageInfo.conditions.appId"
            :placeholder="$t('transactionLogManage.inputAppId')" clearable />
        </el-form-item>
        <el-form-item>
          <el-input v-model="transactionLogManageInfo.conditions.serviceCode"
            :placeholder="$t('transactionLogManage.inputServiceCode')" clearable />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="_queryLogMethod">
            <i class="el-icon-search"></i>
            {{ $t('transactionLogManage.query') }}
          </el-button>
          <el-button @click="_resetLogMethod">
            <i class="el-icon-refresh"></i>
            {{ $t('transactionLogManage.reset') }}
          </el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <el-card class="margin-top-sm">
      <div slot="header" class="clearfix flex justify-between">
        <span>{{ $t('transactionLogManage.transactionLog') }}</span>
      </div>
      <el-table :data="transactionLogManageInfo.logs" border style="width: 100%">
        <el-table-column prop="transactionId" :label="$t('transactionLogManage.transactionId')" align="center" />
        <el-table-column prop="srcIp" :label="$t('transactionLogManage.srcIp')" align="center" />
        <el-table-column prop="appId" :label="$t('transactionLogManage.appId')" align="center" />
        <el-table-column prop="serviceCode" :label="$t('transactionLogManage.serviceCode')" align="center" />
        <el-table-column prop="costTime" :label="$t('transactionLogManage.costTime')" align="center" />
        <el-table-column prop="state" :label="$t('transactionLogManage.state')" align="center">
          <template slot-scope="scope">
            {{ scope.row.state === 'F' ? $t('transactionLogManage.failed') : $t('transactionLogManage.success') }}
          </template>
        </el-table-column>
        <el-table-column prop="createTime" :label="$t('transactionLogManage.createTime')" align="center" />
        <el-table-column :label="$t('transactionLogManage.operation')" align="center">
          <template slot-scope="scope">
            <el-button size="mini" @click="viewLogMessage(scope.row)">
              {{ $t('transactionLogManage.viewMessage') }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination @current-change="handleCurrentChange" :current-page="transactionLogManageInfo.conditions.page"
        :page-size="transactionLogManageInfo.conditions.row" layout="total, prev, pager, next"
        :total="transactionLogManageInfo.total" />
    </el-card>

    <transaction-log-message ref="transactionLogMessage" />
  </div>
</template>

<script>
import { queryTransactionLog } from '@/api/dev/transactionLogApi'
import TransactionLogMessage from '@/components/dev/transactionLogMessage/transactionLogMessage'

export default {
  name: 'TransactionLogManage',
  components: {
    TransactionLogMessage
  },
  data() {
    return {
      transactionLogManageInfo: {
        logs: [],
        total: 0,
        records: 1,
        conditions: {
          appId: '',
          serviceCode: '',
          transactionId: '',
          page: 1,
          row: 10
        }
      }
    }
  },
  created() {
    this._listLogs(1, 10)
  },
  methods: {
    async _listLogs(page, rows) {
      this.transactionLogManageInfo.conditions.page = page
      this.transactionLogManageInfo.conditions.row = rows

      try {
        const res = await queryTransactionLog(this.transactionLogManageInfo.conditions)
        this.transactionLogManageInfo.total = res.total
        this.transactionLogManageInfo.records = res.records
        this.transactionLogManageInfo.logs = res.data
      } catch (error) {
        console.error('请求失败:', error)
      }
    },
    viewLogMessage(log) {
      this.$refs.transactionLogMessage.open(log)
    },
    _queryLogMethod() {
      this._listLogs(1, 10)
    },
    _resetLogMethod() {
      this.transactionLogManageInfo.conditions = {
        appId: '',
        serviceCode: '',
        transactionId: '',
        page: 1,
        row: 10
      }
      this._listLogs(1, 10)
    },
    handleCurrentChange(val) {
      this._listLogs(val, this.transactionLogManageInfo.conditions.row)
    }
  }
}
</script>

<style scoped>
.ecommerce {
  padding: 20px;
}

.el-card {
  margin-bottom: 20px;
}

.el-input {
  width: 100%;
}
</style>